export type AppointmentColors = {
  color?: string
  background?: string
  borderColor?: string
}

/**
 * Applies an appointment's status/category colours to its wrapper element.
 */
export const applyAppointmentColors = (
  element: HTMLElement,
  { color, background, borderColor }: AppointmentColors,
): void => {
  element.style.color = color ?? ''
  element.style.background = background ?? ''
  element.style.border = `4px solid ${borderColor ?? 'var(--light-03)'}`
}
